<template>
    <QxtDropdownMenu ref="dropdownMenu">
        <template #activator>
            <QxtAvatar
                :name="`${profile.firstName} ${profile.lastName}`"
                size="md"
                @click="dropdownMenu?.toggleOpen"
            />
        </template>
        <template #menu>
            <QxtMenu @click="dropdownMenu?.toggleOpen">
                <QxtMenuDropdownOption icon="user">
                    View Profile
                </QxtMenuDropdownOption>
                <QxtMenuDropdownOption
                    icon="log-out"
                    @click="signOut"
                >
                    Logout
                </QxtMenuDropdownOption>
            </QxtMenu>
        </template>
    </QxtDropdownMenu>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { signOut } from 'aws-amplify/auth';
import { QxtAvatar, QxtDropdownMenu, QxtMenu, QxtMenuDropdownOption } from '@asmartment/qui-base';

const dropdownMenu = ref(null);
const store = useStore();
const profile = store.getters['auth/profile'];
</script>
